export default __webpack_public_path__ + "static/media/fonts/outreach.402f1420.svg";